

<template>

    <div id="wrapper" class="clearfix">

        <div v-html="headerHtml">

        </div>

        <!-- Content
        ============================================= -->

        <section id="content">
            <div class="content-wrap">
                <div class="container">
                </div>
                <div class="container clearfix">
                    <div class="heading-block text-center page-section">
                        <h2 class="text-primary">{{$t("HomePage-currentPrograms")}}</h2>
                    </div>
                    <div class="owl-carousel program-carousel" data-pagi="true" data-items-xs="1"
                         data-items-sm="2" data-items-md="3" data-items-lg="4" data-autoplay="3000" data-loop="true">
                        <div class="program-item" v-for="(item, index) in programs" :key="item.Id">
                            <router-link :to="{name:'Programs', params:{id:item.id}}" class="menu-link">
                                <div class="program-image">
                                    <!--<img :src="`${imgBase}Content/images/icon-1.svg`" alt="{{ item.name }}" />-->
                                    <img v-if="item.programLogoFilePath" ref="logoImage" :src="item.programLogoFilePath" :alt="item.name" @error="replaceByDefault" />
                                    <img v-else :src="`${imgBase}Content/images/icon-placeholder.svg`" :alt="item.name" />
                                    <!--<img :src="`${imgBase}Content/images/icon-placeholder.svg`" :alt="item.name" />-->
                                </div>
                                <div class="program-desc">
                                    <h3>{{ item.name }}</h3>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-html="footerHtml">
                </div>
            </div>
        </section><!-- #content end -->

    </div>
    <div id="gotoTop" class="icon-angle-up"></div>


</template>

<script>
    import * as homePageService from './Service/HomePageService'

    export default {
        name: 'HomePageComponent',
        data() {
            return { imgBase: process.env.BASE_URL, programs: [], htmlHeader: "", htmlFooter: "", contactUsURL: "", applicantURL: "https://demo-apps.link.sa/SCFHSHealthAcademy/ApplicantVue/" }
        },

        updated() {

            homePageService.OnCompletedLoadPage();
        },

        computed: {
            headerHtml: function () {

                return this.htmlHeader;
            },
            footerHtml: function () {

                return this.htmlFooter;
            }
        },
        created() {

            homePageService.getAllPrograms(this);

        },
        methods: {
            loadFileHeader() {
                
                homePageService.getHeaderHtml(this);
            },
            loadFileFooter() {
                homePageService.getFooterHtml(this);
            },
            replaceByDefault(e) {
                e.target.src = this.imgBase + "Content/images/icon-placeholder.svg";
                //e.target.style.width = "70px";
                //e.target.style.height = "70px";
            }
        },
    }

</script>
